import { findAllRoles } from '../../_services/rol.service';

export const findAllRolesEvent = async () => {
    let res = await findAllRoles();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}